
import { isEmpty } from 'smartbarcode-web-core/src/utils/typeChecker'
import { Options, Vue } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
@Options({
  emits: ['update:modelValue', 'change'],
  inheritAttrs: false,
  name: 'InputDateTime',
})
export default class InputDateTime extends Vue {
  @Prop({ type: String }) readonly modelValue?: string

  get value() {
    return this.modelValue ? new Date(this.modelValue) : null
  }

  set value(newVal) {
    this.$emit('update:modelValue', newVal ? newVal.toISOString() : null)
  }

  get dateType() {
    return 'datetime'
  }

  @Watch('modelValue')
  modelValueChanged() {
    this.$emit('change')
  }

  convertDate(value: Date) {
    this.$emit('update:modelValue', value ? value.toISOString() : null)
  }

  created() {
    if (isEmpty(this.modelValue)) {
      const currentDate = new Date()
      const initializedDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
        currentDate.getHours(),
        currentDate.getMinutes()
      )

      this.$emit('update:modelValue', initializedDate.toISOString())
    }
  }
}
